import {useState} from 'react';
import DriveSetting from './driveSetting';
import WalkSetting from './walkSetting';
import TransitSetting from './transitSetting';

const NaviSetting = ({
  naviSearch,
  setNaviSearch
}) => {
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false); // 詳細設定の開閉状態

  return (
    <div className={`route-preferences ${isPreferencesOpen ? 'open' : ''}`}>
      <button className="preferences-toggle" title="詳細設定" onClick={() => setIsPreferencesOpen(!isPreferencesOpen)}>
          <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/settings_24.svg')` }}></i>
          <span>詳細設定</span>
          <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/keyboard_arrow_down_24.svg')` }}></i>
      </button>
      <div className="preferences-content" style={{ display: isPreferencesOpen ? 'block' : 'none' }} >

          {/* 車用オプション */}
          <DriveSetting
            naviSearch={naviSearch}
            setNaviSearch={setNaviSearch}
          />  

          {/* 徒歩用オプション */}
          <WalkSetting
            naviSearch={naviSearch}
            setNaviSearch={setNaviSearch}
          />

          {/* 電車用オプション */}
          <TransitSetting
            naviSearch={naviSearch}
            setNaviSearch={setNaviSearch}
          />

      </div>
  </div>
  );
};

export default NaviSetting;